// nearMissValidation.js
// Utility file to validate outgoing near miss form information
// Validation should really only occur for near miss forms that are submitted and not for any other type

export const validateNearMiss = (nearMissData) => {
  const errors = {};

  // Validating the incident date
  if (!nearMissData.incident_date || nearMissData.incident_date.trim() === "") {
    errors.incidentDate = "Incident Date is required";
  } else {
    // Validating the incident date is a valid date
    const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    if (!yyyymmddRegex.test(nearMissData.incident_date)) {
      errors.incidentDate = "Invalid Incident Date";
    }
  }

  // Validating the incident time
  if (!nearMissData.incident_time || nearMissData.incident_time.trim() === "") {
    errors.incidentTime = "Incident Time is required";
  } else {
    // Validating the incident time is a valid time
    const incidentTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!incidentTimeRegex.test(nearMissData.incident_time)) {
      errors.incidentTime = "Invalid Incident Time";
    }
  }

  // Validating the location
  if (!nearMissData.location || nearMissData.location.trim() === "") {
    errors.location = "Location is required";
  }

  // Validating the site
  if (!nearMissData.site || nearMissData.site.trim() === "") {
    errors.site = "Site is required";
  }

  // Validating the reported to
  if (!nearMissData.reported_to || nearMissData.reported_to.trim() === "") {
    errors.reportedTo = "Reported To is required";
  }

  // Validating the reported by
  if (!nearMissData.reported_by || nearMissData.reported_by.trim() === "") {
    errors.reportedBy = "Reported By is required";
  }

  // Validating the near miss description
  if (
    !nearMissData.near_miss_description ||
    nearMissData.near_miss_description.trim() === ""
  ) {
    errors.nearMissDescription = "Near Miss Description is required";
  }

  // Checking if any of the checkboxes are checked or the other section is filled out
  const listOfPotHazards = [
    nearMissData.pot_haz_stf,
    nearMissData.pot_haz_fo,
    nearMissData.pot_haz_ce,
    nearMissData.pot_haz_eh,
    nearMissData.pot_haz_ef,
    nearMissData.pot_haz_ippe,
    nearMissData.pot_haz_mhi,
    nearMissData.pot_haz_feh,
    nearMissData.pot_haz_csi,
    // This is a text section
    nearMissData.pot_haz_other,
  ];

  const isSomethingChecked =
    listOfPotHazards.slice(0, 9).some(Boolean) ||
    (typeof listOfPotHazards[9] === "string" &&
      listOfPotHazards[9].trim() !== "");
  if (!isSomethingChecked) {
    errors.potHazards =
      "At least one potential hazard must be selected or the other section must be filled out";
  }

  // Validating the contributing factors
  if (
    !nearMissData.contributing_factors ||
    nearMissData.contributing_factors.trim() === ""
  ) {
    errors.contributingFactors = "Contributing Factors is required";
  }

  // Validating the actions taken
  if (!nearMissData.actions_taken || nearMissData.actions_taken.trim() === "") {
    errors.actionsTaken = "Actions Taken is required";
  }

  // Validating the suggested corrective actions
  if (
    !nearMissData.sag_corrective_actions ||
    nearMissData.sag_corrective_actions.trim() === ""
  ) {
    errors.sag_corrective_actions = "Suggested Corrective Actions is required";
  }

  // Validating the immediate assessment
  const yesChecked = nearMissData.immediate_ass_yes === true;
  const noChecked = nearMissData.immediate_ass_no === true;
  if (!yesChecked && !noChecked) {
    errors.immediateAss = "At least one immediate assessment must be selected";
  }
  if (yesChecked) {
    if (
      !nearMissData.immediate_ass_yes_description ||
      nearMissData.immediate_ass_yes_description.trim() === ""
    ) {
      errors.immediateAssYesDescription =
        "Immediate Assessment Yes Description is required";
    }
  }

  // Returning both field errors (camelCase keys for form) and nice errors (formatted for notification)
  const niceErrors = {};
  if (errors.incidentDate) niceErrors["Incident Date"] = errors.incidentDate;
  if (errors.incidentTime) niceErrors["Incident Time"] = errors.incidentTime;
  if (errors.location) niceErrors["Location"] = errors.location;
  if (errors.site) niceErrors["Site"] = errors.site;
  if (errors.reportedTo) niceErrors["Reported To"] = errors.reportedTo;
  if (errors.reportedBy) niceErrors["Reported By"] = errors.reportedBy;
  if (errors.nearMissDescription)
    niceErrors["Near Miss Description"] = errors.nearMissDescription;
  if (errors.potHazards) niceErrors["Pot Hazards"] = errors.potHazards;
  if (errors.contributingFactors)
    niceErrors["Contributing Factors"] = errors.contributingFactors;
  if (errors.actionsTaken) niceErrors["Actions Taken"] = errors.actionsTaken;
  if (errors.sag_corrective_actions)
    niceErrors["Suggested Corrective Actions"] = errors.sag_corrective_actions;
  if (errors.immediateAss)
    niceErrors["Immediate Assessment"] = errors.immediateAss;
  if (errors.immediateAssYesDescription)
    niceErrors["Immediate Assessment Yes Description"] =
      errors.immediateAssYesDescription;
  if (errors.signature) niceErrors["Signature"] = errors.signature;
  if (errors.signatureEmployeeId)
    niceErrors["Signature Employee ID"] = errors.signatureEmployeeId;
  if (errors.signatureDate) niceErrors["Signature Date"] = errors.signatureDate;

  return {
    fieldErrors: errors, // camelCase keys for form field display
    notificationErrors: niceErrors, // Nice formatted keys for notification modal
  };
};
